
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { WorksheetCheckStatusCell } from "../WorksheetCheckStatusCell";
import { WorksheetUpdateLogsDialog } from "../WorksheetUpdateLogsDialog";
import { History } from "lucide-react";

interface StatusColumnProps {
  reportId: string;
  normalizedStatus: "WAITING" | "APPROVED" | "REJECTED";
  loadingId: string | null;
  dialogOpenFor: string | null;
  setDialogOpenFor: (id: string | null) => void;
  handleApprove: (status: "APPROVED" | "REJECTED", note: string) => Promise<void>;
  mapStatusToColor: Record<string, string>;
  mapStatusToLabel: Record<string, string>;
  approved_at?: string;
  approved_by?: string;
  approved_note?: string;
}

export const StatusColumn: React.FC<StatusColumnProps> = ({
  reportId,
  normalizedStatus,
  loadingId,
  dialogOpenFor,
  setDialogOpenFor,
  handleApprove,
  mapStatusToColor,
  mapStatusToLabel,
  approved_at,
  approved_by,
  approved_note
}) => {
  const [isLogsOpen, setIsLogsOpen] = useState(false);

  return (
    <div className="flex items-center gap-2">
      <WorksheetCheckStatusCell
        reportId={reportId}
        normalizedStatus={normalizedStatus}
        mapStatusToColor={mapStatusToColor}
        mapStatusToLabel={mapStatusToLabel}
        loadingId={loadingId}
        dialogOpenFor={dialogOpenFor}
        setDialogOpenFor={setDialogOpenFor}
        handleApprove={handleApprove}
        approved_at={approved_at}
        approved_by={approved_by}
        approved_note={approved_note}
      />
      
      {normalizedStatus !== "WAITING" && (
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setIsLogsOpen(true)} 
          title="ดูประวัติการแก้ไข"
          className="p-1 h-8 w-8"
        >
          <History className="h-4 w-4" />
        </Button>
      )}
      
      <WorksheetUpdateLogsDialog 
        open={isLogsOpen} 
        onOpenChange={setIsLogsOpen} 
        reportId={reportId} 
      />
    </div>
  );
};
